// @flow

import ActionTypes from 'app/billing/ActionTypes';
import reducer from 'app/billing/reducer';
import routes from 'app/billing/routes';

export default {
  reducers: {
    billing: reducer,
  },
  actionTypes: ActionTypes,
  routes,
};
